import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCaretRight,
    faRightFromBracket,
    faCreditCard,
} from '@fortawesome/free-solid-svg-icons';
import { appLogo, appName } from '../Constants';
import { Button, Dropdown } from '@quyva/shared-ui';
import { useAuth } from '../context/AuthContext';
import { isFeatureEnabled } from '@quyva/common';
import { Features, OtherFeatures } from '@quyva/common';
import { useFeatureFlags } from '../context';

export const CollapsedSideBar = ({
    setIsRepoViewExpanded,
    planName,
    title,
    icon,
    iconColor,
}) => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const { featureFlagsData } = useFeatureFlags();

    const handleLogoutAction = async () => {
        await logout();
    };
    const user = JSON.parse(localStorage.getItem('current'));
    const currentPlanName = planName || 'FREE';

    const dropDownItems = [
        {
            label: 'Manage Plan',
            icon: faCreditCard,
            action: () => {
                navigate('/current-plan'); // Changed this line to navigate to current-plan
            },
        },
    ];

    if (
        isFeatureEnabled(
            [Features.OTHERS, OtherFeatures.LOGOUT_BUTTON],
            featureFlagsData
        )
    ) {
        dropDownItems.push({
            label: 'Logout',
            icon: faRightFromBracket,
            action: handleLogoutAction,
            type: 'danger',
        });
    }

    // Custom Trigger Button for collapsed state
    const UserInfoButtonTrigger = (
        <div className='flex items-center justify-center'>
            <button
                type='button'
                className='w-8 h-8 rounded-full bg-backgrounds-white border border-backgrounds-primary200 flex items-center justify-center text-sky-300 font-semibold text-base hover:bg-backgrounds-primary100'
            >
                {user?.username.charAt(0).toUpperCase()}
            </button>
        </div>
    );

    return (
        <div className='flex flex-col justify-between items-center w-full h-full border border-2 overflow-none py-5 bg-backgrounds-slate rounded-xl z-10'>
            <div className='flex flex-col justify-center items-center'>
                <img
                    className='w-10 h-10 mx-auto mb-2'
                    src={appLogo}
                    alt={appName}
                    draggable='false'
                />
                <Button
                    icon={faCaretRight}
                    onClick={() => setIsRepoViewExpanded(true)}
                    hoverText={'Expand and show repositories view'}
                    type={'warning'}
                />
            </div>

            <div
                className='w-80'
                style={{
                    transform: 'rotate(90deg)',
                }}
            >
                <div
                    className='flex justify-center items-center text-texts-secondary300 break-keep'
                    style={{
                        transform: 'rotate(180deg)',
                        letterSpacing: '1px',
                    }}
                >
                    <FontAwesomeIcon
                        icon={icon}
                        className={`mr-2 text-${iconColor}`}
                    />
                    <div className='break-keep font-semibold'>{title}</div>
                </div>
            </div>

            <Dropdown
                dropDownList={dropDownItems}
                placement='topRight'
                listTitleText='Account Actions'
                triggerComponent={UserInfoButtonTrigger}
            />
        </div>
    );
};
